import { createStore } from 'jotai';

export const appJotaiStore = createStore();
